import { Autocomplete, Box, Button, CircularProgress, FormControl, IconButton,
  MenuItem, Modal, Select, TextField, Typography, Popover, List, ListItem } from "@mui/material";
import React, { useEffect, useState } from "react";

import { DateNavigator, DayView, Toolbar } from "@devexpress/dx-react-scheduler-material-ui";
import { ViewState, EditingState, IntegratedEditing } from "@devexpress/dx-react-scheduler";
import { Scheduler, WeekView, MonthView, Appointments, AppointmentForm } from "@devexpress/dx-react-scheduler-material-ui";
import ContentBox from "../../components/ui/ContentBox";
import BulkActionsBar from "./BulkActionsBar";
import { modalStyle, modalStyleOverflow, modalStyleVertical } from "../../theme/ModalStyle";
import ButtonSquare from "../../components/ui/ButtonSquare";
import moment from "moment";
import PersonIcon from "@mui/icons-material/Person";
import Api from "../../api/Api";
import { useAuthContext } from "../../hooks/useAuthContext";
import { Urls } from "../../api/Urls";
import { ToastContainer, toast } from "react-toastify";
import { CalendarPicker, DatePicker, DateTimePicker, LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import * as yup from "yup";
import { ErrorMessage, Form, Formik } from "formik";
import FormikErrorText from "../../components/ui/FormikErrorText";
import { PlusOne } from "@mui/icons-material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useNavigate } from "react-router-dom";
import MySwitch from "../../components/ui/MySwitch/MySwitch";
import { colors } from "../../theme/Colors";
function Schedule({ id, showFilters, viewName, dateS }) {
  const [visible, setVisible] = useState(false);
  const [currentViewName, setCurrentViewName] = useState("Week");
  const [court, setCourt] = useState(null);
  const [program, setProgram] = useState("");
  const [openCancelSession, setOpenCancelSession] = useState({ open: false, id: null });
  const [programs, setPrograms] = useState([]);
  const [showFilter, setShowFilter] = useState(showFilters);
  const [showCanceledSlots, setShowCanceledSlots] = useState(false);
  const [loading, setLoading] = useState(true);
  const [programFilter, setProgramFilter] = useState(null);
  const [courts, setCourts] = useState([]);
  const [dataCourts, setDataCourts] = useState([]);
  const { user } = useAuthContext();
  const access_token = user?.access_token;
  const [edit, setEdit] = useState(false);
  const [selectedSession, setSelectedSession] = useState("normal");
  const [dateUpdate, setDateUpdate] = useState(null);
  const [date, setDate] = useState(null);
  const [sessionType, setSessionType] = useState("PROGRAM");
  const [change, setChange] = useState(false);
  const [selectedSessionUpdate, setSelectedSessionUpdate] = useState("");
  const [durations, setDurations] = useState([]);
  const [courtBookingDurations, setCourtBookingDurations] = useState([]);
  const [levels, setLevels] = useState([]);
  const [selectedDate, setSelectedDate] = useState();
  const [terms, setTerms] = useState([]);
  const navigate = useNavigate();
  const [startTime, setStartTime] = useState("");
  const [duration, setDuration] = useState("");
  const [term, setTerm] = useState();
  const [loadingCancel, setLoadingCancel] = useState(false);
  const [dataT, setData] = useState({});
  const [coachFil, setCoachFil] = useState();
  const [schedule, setSchedule] = useState([]);
  const [dateSe, setDateS] = useState(dateS ? dateS : null);
  const [scheduleAdded, setScheduleAdded] = useState([]);
  const [addedScheduleToshow, setAddedScheduleToshow] = useState({
    open: false,
    data: null,
  });
  useEffect(() => {
    document.title = "BTA admin - Schedule";
  }, []);

  const [initialValuesNorml, setInitialValuesNorml] = useState({
    program: "",
    levels: [],
    start_time: "",
    duration: "",
    coach: "",
  });
  const [initialValuesPrv, setInitialValuesPrv] = useState({
    program: "",
    levels: [],
    start_time: new Date(),
    duration: "",
    coach: "",
  });

  const [initialValuesCourtBooking, setInitialValuesCourtBooking] = useState({
    start_time: new Date(),
    duration: "",
  });

  const handleClickCancel = (id) => {
    setOpenCancelSession({ open: true, id: id });
  };
  const handleCloseCancel = () => {
    setOpenCancelSession({ open: false, id: null });
  };
  const handleCloseUpdate = () => {
    setOpenDetails({
      open: false,
      data: null,
    });
    setOpenCancelSession({ id: null, open: false });
    setVisible(false);
    setInitialValuesNorml({
      program: program,
      levels: [],
      start_time: "",
      duration: "",
      coach: "",
    });
    setInitialValuesPrv({
      program: program,
      levels: [],
      start_time: "",
      duration: "",
      coach: "",
    });
    setInitialValuesCourtBooking({
      start_time: "",
      duration: "",
    })

  };
  useEffect(() => {
    if (showFilters === false) {
      setShowFilter(false);
    } else {
      setShowFilter(true);
    }
    if (viewName === "Day") {
      setCurrentViewName("Day");
    }
  }, [showFilters]);



  const validationSchema = yup.object({
    program: yup?.object().shape({
      id: yup?.string().required("This field is required"),
    }),
    /*level: yup?.object().shape({
      id: yup?.string().required("This field is required"),
    }),*/
    levels: yup
        .array()
        .of(
            yup.object().shape({
              id: yup.string().required("Level id is required"),
            })
        )
        .min(1, "Select at least one level")
        .required("Level(s) is required"),
    start_time: yup?.string().required("this field is required"),
    duration: yup?.object().shape({
      duration: yup?.string().required("This field is required"),
    }),
    coach: yup?.string().required("this field is required"),
  });
  const validationSchemaPrivate = yup.object({
    start_time: yup
        .mixed()
        .test('is-date', 'Start time must be a valid date', (value) => value instanceof Date)
        .required('This field is required'),
    duration: yup.object().shape({
      duration: yup.string().required("This field is required"),
    }),
    coach: yup.string().required("This field is required"),
  });

  const validationSchemaCourtBooking = yup.object({
    start_time: yup
        .mixed()
        .test('is-date', 'Start time must be a valid date', (value) => value instanceof Date)
        .required('This field is required'),
    duration: yup?.object().shape({
      duration: yup?.string().required("This field is required"),
    }),
  });

  const [openDetails, setOpenDetails] = useState({
    open: false,
    data: null,
  });

  const ExternalViewSwitcher = ({ currentViewName }) => (
      <Box display="flex" flexDirection="row" justifyContent="flex-end" alignItems="flex-end">
        <Box display="flex" flexDirection="row">
          {showFilter !== false && (
              <Button onClick={() => setCurrentViewName("Month")} variant={currentViewName === "Month" ? "views_active_left_radius" : "views_inactive_left_radius"}>
                Month
              </Button>
          )}
          {showFilter !== false && (
              <Button onClick={() => setCurrentViewName("Week")} variant={currentViewName === "Week" ? "views_active" : "views_inactive"}>
                Week
              </Button>
          )}
          {showFilter !== false && (
              <Button onClick={() => setCurrentViewName("Day")} variant={currentViewName === "Day" ? "views_active_right_radius" : "views_inactive_right_radius"}>
                Day
              </Button>
          )}
        </Box>
      </Box>
  );
  useEffect(() => {
    Api.get(Urls.GET_PRIVATE_LESSONS, {
      headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
    })
        .then((res) => {
          setDurations(res?.data?.data);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        });
  }, []);

  useEffect(() => {
    Api.get(Urls.GET_COURT_BOOKINGS, {
      headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
    })
        .then((res) => {
          setCourtBookingDurations(res?.data?.data);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        });
  }, []);

  // handlers
  const handleClickAppointment = (data, edit) => {
    setEdit(edit);
    setOpenDetails({
      open: true,
      data: data,
    });

    if (data?.session_type === "PROGRAM") {
      //let start_time = moment(data?.start_datetime, "HH:mm:ss").format("hh:mm A");

      let start_time = moment(data.start_datetime).format("hh:mm A");

      setDuration(data?.duration);
      setStartTime(start_time);

      setSelectedSessionUpdate(data?.session_type === "PROGRAM" ? "normal" : "private");
      setInitialValuesNorml({
        program: { id: data?.program_id, name: data?.program_name },
        start_time: new Date(data?.start_datetime),
        duration: { id: null, duration: data?.duration },
        coach: data?.coach_id,
        coach_first_name: data?.coach_first_name,
        coach_last_name: data?.coach_last_name,
        //level: { id: data?.level_id, name: data?.level_name },
        levels:
            data?.levels && data?.levels.length > 0
                ? data.levels
                : [{ id: data?.level_id, name: data?.level_name }],
        cancelled_at: data?.cancelled_at,
      });
    }
    if (data?.session_type === "PRIVATE_LESSON") {
      //setDateUpdate(data?.start_datetime);
      setDate(data?.start_datetime);
      setDuration(data?.duration);
      setStartTime(data?.start_datetime);

      Api.get(Urls.GET_PRIVATE_LESSONS, {
        headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
      })
          .then((res) => {
            setDurations(res?.data?.data);
            setSelectedSessionUpdate("private");
            setInitialValuesPrv({
              start_time: new Date(data?.start_datetime),
              duration: { id: null, duration: data?.duration },
              coach: data?.coach_id,
              coach_first_name: data?.coach_first_name,
              coach_last_name: data?.coach_last_name,
            });
          })
          .catch((err) => {
            toast.error(err?.response?.data?.message);
          });
    }
    if (data?.session_type === "COURT_BOOKING") {
      let start_time = moment(data?.start_time, "HH:mm:ss").format("hh:mm A");
      //setDateUpdate(data?.start_datetime);
      setDate(data?.start_datetime);
      setCourtBookingDurations(data?.duration);
      setStartTime(data?.start_datetime);
      Api.get(Urls.GET_COURT_BOOKINGS, {
        headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
      })
          .then((res) => {
            setCourtBookingDurations(res?.data?.data);
            setSelectedSessionUpdate("court");
            setInitialValuesCourtBooking({
              start_time: new Date(data?.start_datetime),
              duration: { id: null, duration: data?.duration },
            });
          })
          .catch((err) => {
            toast.error(err?.response?.data?.message);
          });
    }
  };
  const handleClickAppointementPlus = (data) => {

    const array = scheduleAdded.filter((schedule) => schedule.startDate.split(" ")[0] === data?.startDate.split(" ")[0]);
    const array_2 = schedule.filter((schedule) => schedule.startDate.split(" ")[0] === data?.startDate.split(" ")[0] && !schedule?.new);
    const global_array = array_2.concat(array);
    setAddedScheduleToshow({
      open: true,
      data: global_array,
    });
  };
  //reorganize data in better shape to be used
  const limitOccurenceNumber = (data, cancelled) => {
    if (data?.length > 0) {
      let reorganizedArray = [];
      let addedArray = [];
      for (let index = 0; index < data.length; index++) {
        let count = 1;
        const element = data[index];
        reorganizedArray.push(element);
        for (let i = index + 1; i < data.length; i++) {
          const elementToCompare = data[i];
          if (element?.startDate.split(" ")[0] === elementToCompare?.startDate.split(" ")[0] && count < 2) {
            reorganizedArray.push(elementToCompare);
            count = count + 1;
            if (i === data?.length - 1) {
              data = data?.filter((da) => da?.startDate?.split(" ")[0] !== element?.startDate?.split(" ")[0]);
              data.unshift(null);
            }
          } else {
            if (count === 2 && element?.startDate.split(" ")[0] === elementToCompare?.startDate.split(" ")[0]) {
              reorganizedArray.push({ ...element, new: true, startDate: element?.startDate?.split(" ")[0] + " 23:59:00", endDate: element?.endDate?.split(" ")[0] + " 23:59:10" });
              count = count + 1;
            }
            if (count > 2 && element?.startDate.split(" ")[0] === elementToCompare?.startDate.split(" ")[0]) {
              addedArray.push(elementToCompare);
            }
            if (i === data?.length - 1) {
              data = data?.filter((da) => da?.startDate?.split(" ")[0] !== element?.startDate?.split(" ")[0]);
              data.unshift(null);
            }
          }
        }
      }
      if (cancelled) {
        setSchedule(reorganizedArray);
        setScheduleAdded(addedArray);
      } else {
        setSchedule(reorganizedArray?.filter((data) => data?.cancelled_at === null));
        setScheduleAdded(addedArray?.filter((data) => data?.cancelled_at === null));
      }
    }
  };
  //get coachs filter
  const [users, setUsers] = useState([]);
  useEffect(() => {
    Api.get(Urls?.GET_COACHES, {
      headers: { "content-type": "application/json", Authorization: `Bearer ${access_token}` },
    })
        .then((res) => {
          setUsers(res?.data?.data);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        });
  }, []);
  //get global schedule
  useEffect(() => {
    setLoading(true);
    if (term) {
      setSchedule([]);
      const date = new Date(selectedDate);

      date.setDate(1);
      const firstDay = new Date(date + 1);

      date.setMonth(date.getMonth() + 1);
      date.setDate(1);
      const lastDay = new Date(date);
      if (term?.id) {
        Api.get(Urls?.GET_GLOBAL_SCHEDULE + term?.id + "/courtSchedules", {
          headers: { "Content-Type": "application/json", authorization: `Bearer ${access_token}` },
          params: {
            ...(court?.id ? { courtId: court?.id } : null),
            ...(sessionType === "PROGRAM" && programFilter ? { programId: programFilter?.id } : {}),
            ...(sessionType === "PRIVATE_LESSON" && { sessionType: "PRIVATE_LESSON" }),
            ...(sessionType === "COURT_BOOKING" && { sessionType: "COURT_BOOKING" }),
            ...(coachFil?.id ? { coachId: coachFil?.id } : null),
            ...(selectedDate && showFilter ? { startDatetime: new Date(term?.start_date) } : { startDatetime: new Date(term?.start_date) }),
            ...(selectedDate && showFilter ? { endDatetime: new Date(term?.end_date) } : { endDatetime: new Date(term?.end_date) }),
          },
        })
            .then((res) => {
              let data = [];


              if (res?.data?.data?.length > 0) {
                for (let index = 0; index < res?.data?.data?.length; index++) {
                  const element = res?.data?.data[index];
                  data.push({ ...element, startDate: element?.start_datetime, endDate: element?.end_datetime });
                }
                if (currentViewName === "Month") {
                  limitOccurenceNumber(data, showCanceledSlots);
                } else {
                  if (showCanceledSlots) {
                    setSchedule(data);
                  } else {
                    setSchedule(data?.filter((d) => d?.cancelled_at === null));
                  }
                }
              }
              setLoading(false);
            })
            .catch((err) => {
              toast?.error(err?.response?.data?.message);
              setLoading(false);
            });
      }
    }
    setLoading(false);
  }, [program, court, change, coachFil, currentViewName, term, sessionType, selectedSession, programFilter, showCanceledSlots]);
  useEffect(() => {
    if (term) {
      setSelectedDate(new Date() > new Date(term?.start_date) && new Date() < new Date(term?.end_date) ? new Date() : new Date(term?.start_date));
    }
  }, [term]);

  //get list courts
  useEffect(() => {
    Api.get(Urls.GET_COURTS_LIST, {
      headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
    })
        .then((response) => {
          setCourts(response?.data?.data);
          setDataCourts(response?.data);
          setCourt(response?.data?.data[0]);
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
  }, []);
  const [dataProg, setDataProg] = useState([]);
  //get list programs
  useEffect(() => {
    Api.get(Urls.GET_PROGRAMS, {
      headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
    })
        .then((response) => {
          setPrograms(response?.data?.data);
          setDataProg(response?.data);
          setLevels(response?.data?.data[0]?.levels);
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
  }, []);
  //get list terms
  useEffect(() => {
    Api.get(Urls.GET_TERMS_LIST, {
      headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
    })
        .then((response) => {
          setTerms(response?.data?.data);
          setData(response?.data);
          setTerm(response?.data?.data[0]);
          if (showFilters === false) {
            for (let index = 0; index < response?.data?.data.length; index++) {
              let Term = response?.data?.data[index];
              if (new Date() > new Date(Term?.start_date) && new Date() < new Date(Term?.end_date)) {
                setTerm(Term);
              }
            }
          }
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
  }, []);
  const [coachs, setCoachs] = useState([]);

  useEffect(() => {
    if (term && startTime && selectedSessionUpdate === "private") {
      let startTime_ = new Date(startTime);
      startTime_ = moment(startTime_, "");
      let endTime = startTime_?.clone().add(duration?.duration ? duration?.duration : duration, "minutes");
      Api.get(Urls?.GET_AVAILABLE_COACHS, {
        headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
        params: {
          startDatetime: moment(startTime_).format("YYYY-MM-DD HH:mm:00"),
          endDatetime: moment(endTime).format("YYYY-MM-DD HH:mm:00"),
        },
      })
          .then((res) => {
            let coachList = res?.data?.data?.filter((coach) => coach.id !== initialValuesPrv?.coach);
            setCoachs(coachList);
          })
          .catch((err) => {
            toast?.error(err?.response?.data?.message);
          });
    }
  }, [term, duration, startTime]);

  const CustomAppointmentContent = ({ data, ...restProps }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handlePopoverOpen = (event) => {
      event.stopPropagation(); // Empêcher la propagation pour ne pas déclencher handleClickAppointment
      setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = (event) => {
      if (event) event.stopPropagation();
      setAnchorEl(null);
    };
    // Customize the appointment content based on data properties
    const customStyles = {
      background: data?.program_color_start && data?.program_color_end ? `linear-gradient(-30deg, #${data?.program_color_start}, #${data?.program_color_end})` : data?.session_type === "PRIVATE_LESSON" ? "#1E213E" : "#005F78",
      // color: data?.session_type === "PROGRAM" ? data?.color : "white", // Default text color
      color: data?.new ? "white" : getContrastColor(data?.program_color_start),
      height: data?.new ? "70%" : "100%",
      width: data?.new ? "20px" : currentViewName !== "Week" && currentViewName !== "Day" ? "90%" : "100%",
      boxShadow: "0",
      ":hover": { filter: "brightness(0.95)" },
      filter: data?.new ? "brightness(1)" : data?.cancelled_at ? "brightness(0.6)" : "brightness(1)",
      cursor: "pointer",
    };

    //const selectedSession = data?.session_type === "PROGRAM" ? false : true;
    return (
        <>
          {!data?.new && (
              <Box
                  onClick={() => handleClickAppointment(data, selectedSession)}
                  sx={customStyles}
                  display="flex"
                  justifyContent="center"
                  alignItems="center">
                {/* Render appointment content here */}
                {data?.levels?.length > 0 && (
                    <Box position="absolute" top="4px" right="4px" display="flex" gap="4px">
                      {data?.levels && data.levels.slice(0, 2).map((level, index) => (
                          <Box
                              key={index}
                              borderRadius="3px"
                              padding="1px 4px"
                              bgcolor="#D0CFCF"
                          >
                            <Typography fontSize="11px" fontWeight="600" color="black">
                              {(level.name || "").length > 3
                                  ? (level.name || "").substring(0, 3)
                                  : (level.name || "")}
                            </Typography>
                          </Box>
                      ))}
                      {data?.levels && data.levels.length > 2 && (
                          <>
                            <Box
                                borderRadius="3px"
                                padding="1px 4px"
                                bgcolor="#D0CFCF"
                                sx={{ cursor: "pointer" }}
                                onClick={handlePopoverOpen}
                            >
                              <Typography fontSize="11px" fontWeight="600" color="black">
                                •••
                              </Typography>
                            </Box>

                            <Popover
                                open={open}
                                anchorEl={anchorEl}
                                onClose={handlePopoverClose}
                                onClick={(e) => e.stopPropagation()}
                                anchorOrigin={{
                                  vertical: "bottom",
                                  horizontal: "right",
                                }}
                                transformOrigin={{
                                  vertical: "top",
                                  horizontal: "right",
                                }}
                            >
                              <List sx={{ p: 1, maxHeight: "200px", overflow: "auto" }}>
                                {data.levels.map((l, index) => (
                                    <ListItem key={index} sx={{ py: 0.5 }}>
                                      <Typography fontSize="13px">{l.name || ""}</Typography>
                                    </ListItem>
                                ))}
                              </List>
                            </Popover>
                          </>
                      )}
                    </Box>
                )}
                <Typography
                    textAlign="center"
                    color="inherit"
                    fontSize="13px"
                    lineHeight="14px"
                    fontWeight="500"
                >
                  {data?.program_name ? data?.program_name : (data.session_type === "PRIVATE_LESSON" ? "PRIVATE LESSON" : "COURT BOOKING")}
                </Typography>
              </Box>
          )}
          {data?.new && (
              <Box sx={{ width: "90%" }} onClick={() => handleClickAppointementPlus(data)} display="flex"
                   justifyContent="center" alignItems="center">
                <Box borderRadius="6px" marginTop="4px" sx={customStyles} display="flex" justifyContent="center">
                  <MoreHorizIcon sx={{ fontSize: 15 }} />
                </Box>
              </Box>
          )}
        </>
    );
  };
  // QW6 — surface non-blocking court/coach overlap warnings returned by the backend.
  const surfaceWarnings = (res) => {
    const w = res?.data?.data?.warnings;
    if (!w) return;
    const courtN = (w.court_conflicts || []).length;
    const coachN = (w.coach_conflicts || []).length;
    if (courtN || coachN) {
      toast.warn(
        `Saved with ${courtN} court overlap${courtN === 1 ? "" : "s"} and ${coachN} coach overlap${coachN === 1 ? "" : "s"} — review the schedule`,
        { autoClose: 6000 }
      );
    }
  };

  const submitUpdatePrivateCourt = (values) => {
    const startTimeFormatted = moment(values.start_time).format("YYYY-MM-DD HH:mm:ss");
    Api.patch(
        Urls.UPDATE_PRIVATE_LESSON_GLOBAL + openDetails?.data?.id,
        {
          court_id: court?.id,
          term_id: term?.id,
          coach_id: values?.coach,
          ...(values?.duration?.id ? { private_lesson_id: values?.duration?.id } : null),
          start_time: startTimeFormatted,
          ...(values?.max_players !== "" && values?.max_players != null && { max_players: Number(values.max_players) }),
        },
        {
          headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
        }
    )
        .then((res) => {
          toast?.success("updated");
          surfaceWarnings(res);
          handleCloseUpdate();
          setChange(!change);
        })
        .catch((err) => {
          toast?.error(err?.response?.data?.message);
        });
  };


  const submitCreatePrivateLesson = (values) => {
    const startTimeFormatted = moment(values.start_time).format("YYYY-MM-DD HH:mm:ss");
    console.log('values from submitCreatePrivateLesson: ', values);
    Api.post(
        Urls.REPLACE_PROGRAM_SCHEDULE,
        {
          court_id: court?.id,
          term_id: term?.id,
          coach_id: values?.coach,
          private_lesson_id: values?.duration?.id,
          start_datetime: startTimeFormatted,
          ...(values?.max_players !== "" && values?.max_players != null && { max_players: Number(values.max_players) }),
        },
        {
          headers: {"content-type": "application/json", authorization: `Bearer ${access_token}`},
        }
    )
        .then((res) => {
          toast?.success("created");
          surfaceWarnings(res);
          handleCloseUpdate();
          setVisible(false);
          setChange(!change);
        })
        .catch((err) => {
          toast?.error(err?.response?.data?.message);
        });
  };
  const submitCreateCourtBooking = (values) => {
    const startTimeFormatted = moment(values.start_time).format("YYYY-MM-DD HH:mm:ss");
    console.log('values from submitCreateCourtBooking: ', values);
    Api.post(
        Urls.REPLACE_PROGRAM_SCHEDULE,
        {
          court_id: court?.id,
          term_id: term?.id,
          court_booking_id: values?.duration?.id,
          start_datetime: startTimeFormatted,
          ...(values?.max_players !== "" && values?.max_players != null && { max_players: Number(values.max_players) }),
        },
        {
          headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
        }
    )
        .then((res) => {
          toast?.success("created");
          surfaceWarnings(res);
          handleCloseUpdate();
          setVisible(false);
          setChange(!change);
        })
        .catch((err) => {
          toast?.error(err?.response?.data?.message);
        });
  };

  const submitUpdateCourtBooking= (values) => {};

  const handleCancelAppointement = (bool) => {
    setLoadingCancel(true);
    Api.post(
        Urls.CANCEL_APPOINTEMENT + openDetails?.data?.id + "/cancel",
        {
          refund: bool ? 1 : 0,
        },
        {
          headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
        }
    )
        .then((res) => {
          toast?.success("Canceled");
          setChange(!change);
          setLoadingCancel(false);

          handleCloseUpdate();
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
          setLoadingCancel(false);
        });
  };

  //background color & text color management for schedules
  const hexToRgb = (hex) => {
    const bigint = parseInt(hex?.slice(1), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return [r, g, b];
  };

  const getContrastColor = (backgroundColor) => {
    const calculateLuminance = (rgb) => {
      const [r, g, b] = rgb.map((value) => {
        value /= 255;
        return value <= 0.03928 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4);
      });

      return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    };

    const rgb = hexToRgb(backgroundColor);
    const luminance = calculateLuminance(rgb);

    return luminance > 0.5 ? "black" : "white";
  };
  /* useEffect(() => {
     setInitialValuesPrv({
       program: program,
       levels: [],
       start_time: new Date(date),
       duration: "",
       coach: "",
     });
     setStartTime(new Date(date));
   }, [date]);*/
  return (
      <Box>
        <BulkActionsBar onSuccess={() => setChange((c) => !c)} />
        {showFilters === false ? (
            <ContentBox>
              <Box sx={{ overflowX: { xs: "scroll", sm: "scroll", md: "hidden", lg: "hidden" }, flexDirection: { xs: "column", sm: "column", md: "column", lg: "row" } }} display="flex" gap="26px">
                {showFilter && (
                    <Box flex={1} display="flex" flexDirection="column" gap="12px">
                      <Box>
                        <Typography fontSize="13px" fontWeight={400} lineHeight="20px" color="#4B465C">
                          Filter
                        </Typography>
                      </Box>
                      <Box>
                        <Typography fontSize="13px" fontWeight={400} lineHeight="20px" color="#4B465C">
                          Program
                        </Typography>
                        <Autocomplete
                            sx={{ minWidth: "200px" }}
                            options={programs}
                            disableClearable={true}
                            getOptionLabel={(e) => e.name}
                            isOptionEqualToValue={(option) => option?.id}
                            onChange={(event, value) => {
                              if (value !== null) {
                                setProgram(value?.id);
                              } else {
                                setProgram(null);
                              }
                            }}
                            renderInput={(params) => <TextField {...params} name="autocomplete" placeholder="Select type user" />}
                        />
                      </Box>
                      <Box>
                        <Typography fontSize="13px" fontWeight={400} lineHeight="20px" color="#4B465C">
                          Coach
                        </Typography>
                        <Autocomplete
                            sx={{ minWidth: "200px" }}
                            options={users}
                            getOptionLabel={(e) => e.first_name + " " + e.last_name}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            onChange={(event, value) => {
                              if (value !== null) {
                                setCoachFil(value);
                              } else {
                                setCoachFil(null);
                              }
                            }}
                            renderInput={(params) => <TextField {...params} name="autocomplete" placeholder="Select coach" />}
                        />
                      </Box>
                      <Box>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <CalendarPicker
                              date={selectedDate}
                              maxDate={term?.end_date}
                              minDate={term?.start_date}
                              onChange={(newValue) => {
                                setSelectedDate(newValue);
                              }}
                              renderInput={(params) => <TextField {...params} />}
                          />
                        </LocalizationProvider>
                      </Box>
                    </Box>
                )}

                <Box flex={4} borderLeft={showFilters === false ? "none" : "1px solid lightgray"}>
                  {!loading && (
                      <Scheduler data={schedule} height={700}>
                        <ViewState onCurrentDateChange={!dateS ? (date) => (new Date(term?.end_date) > new Date(date) ? setSelectedDate(date) : null) : (date) => (new Date(date) <= new Date(term?.end_date) ? setDateS(date) : null)} currentDate={dateS ? dateSe : selectedDate} currentViewName={currentViewName} />
                        <WeekView cellDuration={30} startDayHour={6} endDayHour={22} />
                        <MonthView />
                        <DayView cellDuration={30} startDayHour={6} endDayHour={22} />
                        <Appointments appointmentComponent={CustomAppointmentContent} />

                        <Toolbar />
                        <Box marginLeft="20px" display="flex" alignItems="center" justifyContent="space-between">
                          <Typography fontSize="18px" fontWeight="500" lineHeight="24px" color="#4B465C">
                            TERM : {term?.name} {court?.name ? " / " : ""} {court?.name}{" "}
                          </Typography>
                          {showFilters === false && (
                              <Box>
                                <Button onClick={() => navigate("/admin/schedules")} variant="primary_active">
                                  Go to schedule
                                </Button>
                              </Box>
                          )}
                        </Box>
                        <DateNavigator onCurrentDateChange={(date) => console.log(date)} />
                        <ExternalViewSwitcher currentViewName={currentViewName} />
                      </Scheduler>
                  )}
                  {loading && (
                      <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <CircularProgress />{" "}
                      </Box>
                  )}
                </Box>

                 {/*Modal 1*/}
                <Modal open={openDetails?.open} onClose={handleCloseUpdate}>
                  <Box sx={modalStyleVertical}>
                    <Box>
                      <Box marginBottom="26px" alignItems="center" display="flex" justifyContent="space-between">
                        <Box>
                          <Typography fontSize="18px" lineHeight="24px" fontWeight="500" color="#4B465C">
                            Schedule session for {moment(openDetails?.data?.start_datetime).format("dddd, MMMM DD, yyyy hh:mm A")}
                          </Typography>
                        </Box>
                        <ButtonSquare action="close" onClick={handleCloseUpdate} />
                      </Box>
                      <Box display="flex" gap="4px" marginBottom="24px">
                        <Box>
                          <Button variant={selectedSessionUpdate === "normal" ? "primary_active" : "primary_inactive"}>Schedule a session</Button>
                        </Box>
                        <Box>
                          <Button
                              onClick={() => {
                                if (selectedSessionUpdate === "normal") {
                                  setOpenDetails({
                                    open: false,
                                    data: null,
                                  });

                                  setVisible(true);
                                  setDate(initialValuesNorml?.start_time);
                                  setEdit(true);
                                  setSelectedSessionUpdate("private");
                                }
                              }}
                              variant={selectedSessionUpdate !== "normal" ? "primary_active" : "primary_inactive"}
                          >
                            Schedule a private session
                          </Button>
                        </Box>
                      </Box>
                      {selectedSessionUpdate === "normal" && (
                          <Formik onSubmit={(values) => console.log(values)} validationSchema={validationSchema} initialValues={initialValuesNorml} enableReinitialize={true}>
                            {({ errors, setFieldValue, values }) => (
                                <Form>
                                  <Box display="flex" flexDirection="column" gap="16px">
                                    <Box>
                                      <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                        Program
                                      </Typography>
                                      <Autocomplete
                                          sx={{ minWidth: "300px" }}
                                          options={[]}
                                          value={values?.program}
                                          disabled={!edit}
                                          getOptionLabel={(e) => e.name}
                                          isOptionEqualToValue={(option, value) => option?.id === value.id}
                                          renderInput={(params) => <TextField {...params} name="autocomplete" placeholder="Select program" />}
                                          onChange={(event, value) => {
                                            if (value !== null) {
                                              setFieldValue("program", value);
                                              setFieldValue("coach", null);
                                              setProgram(value);
                                              setFieldValue("duration", null);
                                            } else {
                                              setFieldValue("program", null);
                                            }
                                          }}
                                      />
                                      <ErrorMessage component={FormikErrorText} name="program" />
                                    </Box>

                                    <Box>
                                      <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                        Levels
                                      </Typography>
                                      <Autocomplete
                                          /*onChange={(event, value) => {
                                            if (value !== null) {
                                              //console.log("selecting facture state value", value);
                                              //console.log("selecting facture state value", value.id);
                                              setFieldValue("level", value);
                                              //console.log("selectedFicheDePaieState", selectedFicheDePaieState);
                                            } else {
                                              setFieldValue("level", null);
                                            }
                                          }}*/
                                          onChange={(event, newValue) => setFieldValue("levels", newValue)}
                                          sx={{ minWidth: "300px" }}
                                          options={levels}
                                          disabled={!edit}
                                          //value={values?.level ? values?.level : null}
                                          value={values.levels || []}
                                          getOptionLabel={(e) => e.name}
                                          isOptionEqualToValue={(option, value) => option?.id === value.id}
                                          renderInput={(params) => <TextField {...params} name="autocomplete" placeholder="Select level" />}
                                      />
                                      <ErrorMessage component={FormikErrorText} name="levels" />
                                    </Box>
                                    <Box>
                                      <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                        Start time
                                      </Typography>
                                      <Autocomplete
                                          onChange={(event, value) => {
                                            if (value !== null) {
                                              setFieldValue("start_time", value);
                                              setStartTime(value);
                                              setFieldValue("coach", null);

                                            } else {
                                              setFieldValue("start_time", null);
                                              setStartTime(null);
                                              setFieldValue("coach", null);
                                            }
                                          }}
                                          sx={{ minWidth: "300px" }}
                                          options={[]}
                                          disabled={!edit}
                                          value={moment(values?.start_time).format("DD MMMM YYYY hh:mm A")}
                                          getOptionLabel={(e) => e}
                                          isOptionEqualToValue={(option, value) => option === value}
                                          renderInput={(params) => <TextField {...params} name="autocomplete" placeholder="Select start time" />}
                                      />
                                      <ErrorMessage component={FormikErrorText} name="start_time" />
                                    </Box>
                                    <Box>
                                      <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                        Duration
                                      </Typography>
                                      <Autocomplete
                                          sx={{ minWidth: "300px" }}
                                          options={[]}
                                          disabled={!edit}
                                          value={values?.duration ? values?.duration : null}
                                          getOptionLabel={(e) => e?.duration?.toString()}
                                          isOptionEqualToValue={(option, value) => option?.duration === value?.duration}
                                          renderInput={(params) => <TextField {...params} name="autocomplete" placeholder="Select duration" />}
                                          onChange={(event, value) => {
                                            if (value !== null) {
                                              setFieldValue("duration", value);
                                              setDuration(value);
                                              setFieldValue("coach", null);
                                            } else {
                                              setFieldValue("duration", null);
                                              setDuration(null);
                                            }
                                          }}
                                      />
                                      <ErrorMessage component={FormikErrorText} name="duration" />
                                    </Box>
                                    <Box>
                                      <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                        Coach
                                      </Typography>
                                      <FormControl sx={{ height: "42px" }} fullWidth>
                                        <Select
                                            onChange={(e) => {
                                              setFieldValue("coach", e.target?.value);
                                            }}
                                            disabled={!edit}
                                            value={values?.coach}
                                            placeholder="Select coach"
                                            sx={{ height: "42px", borderColor: "#DEDFE4" }}
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                        >
                                          <MenuItem key={values?.coach} value={values?.coach}>
                                            <Box display="flex" alignItems="center" gap="5px">
                                              <Box marginTop="5px">{values?.coach?.url_avatar ? <img src={values?.coach?.url_avatar} style={{ height: "32px", width: "32px", borderRadius: "50%" }} alt="proile-pic" /> : <PersonIcon sx={{ fontSize: "25px" }} />}</Box>
                                              <Box>{values?.coach_first_name + " " + values?.coach_last_name}</Box>
                                            </Box>
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                      <ErrorMessage component={FormikErrorText} name="coach" />
                                    </Box>
                                    <Box display="flex" gap="16px" alignItems="center">
                                      {!openDetails?.data?.cancelled_at && (
                                          <Button onClick={() => handleClickCancel(openDetails?.data?.id)} variant="primary_active">
                                            Cancel
                                          </Button>
                                      )}
                                      <Button onClick={handleCloseUpdate} variant="primary_inactive">
                                        Close
                                      </Button>
                                      <Button variant="primary_active" onClick={() => navigate("/admin/players/schedule", { state: { data: openDetails?.data } })}>
                                        Go to details
                                      </Button>
                                    </Box>
                                  </Box>
                                </Form>
                            )}
                          </Formik>
                      )}
                      {selectedSessionUpdate === "private" && (
                          <Formik onSubmit={(values) => submitUpdatePrivateCourt(values)} validationSchema={validationSchemaPrivate} initialValues={initialValuesPrv} enableReinitialize={true}>
                            {({ errors, setFieldValue, values }) => (
                                <Form>
                                  <Box display="flex" flexDirection="column" gap="16px">
                                    <Box>
                                      <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                        Start time
                                      </Typography>
                                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DateTimePicker
                                            value={values.start_time}
                                            onChange={(value) => {
                                              setStartTime(new Date(value));
                                              setFieldValue("start_time", value);
                                              setFieldValue("coach", null);
                                            }}
                                            ampm={false}
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                      </LocalizationProvider>
                                      <ErrorMessage component={FormikErrorText} name="start_time" />
                                    </Box>
                                    <Box>
                                      <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                        Duration
                                      </Typography>
                                      <Autocomplete
                                          sx={{ minWidth: "300px" }}
                                          options={durations}
                                          disabled={!edit}
                                          value={values?.duration ? values?.duration : null}
                                          getOptionLabel={(e) => e?.duration?.toString()}
                                          isOptionEqualToValue={(option, value) => option?.duration === value?.duration}
                                          renderInput={(params) => <TextField {...params} name="autocomplete" placeholder="Select duration" />}
                                          onChange={(event, value) => {
                                            if (value !== null) {
                                              setFieldValue("duration", value);
                                              setDuration(value);
                                              setFieldValue("coach", null);
                                            } else {
                                              setFieldValue("duration", null);
                                              setDuration(null);
                                            }
                                          }}
                                      />
                                      <ErrorMessage component={FormikErrorText} name="duration" />
                                    </Box>
                                    <Box>
                                      <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                        Coach
                                      </Typography>
                                      <FormControl sx={{ height: "42px" }} fullWidth>
                                        <Select
                                            onChange={(e) => {
                                              setFieldValue("coach", e.target?.value);
                                            }}
                                            value={values?.coach}
                                            disabled={!edit}
                                            placeholder="Select coach"
                                            sx={{ height: "42px", borderColor: "#DEDFE4" }}
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                        >
                                          {coachs?.map((coach) => (
                                              <MenuItem key={coach?.id} value={coach?.id}>
                                                <Box display="flex" alignItems="center" gap="5px">
                                                  <Box marginTop="5px">{coach?.url_avatar ? <img src={coach?.url_avatar} style={{ height: "32px", width: "32px", borderRadius: "50%" }} alt="proile-pic" /> : <PersonIcon sx={{ fontSize: "25px" }} />}</Box>
                                                  <Box>{coach?.first_name + " " + coach?.last_name}</Box>
                                                </Box>
                                              </MenuItem>
                                          ))}
                                          <MenuItem key={values?.coach} value={values?.coach}>
                                            <Box display="flex" alignItems="center" gap="5px">
                                              <Box marginTop="5px">{values?.coach?.url_avatar ? <img src={values?.coach?.url_avatar} style={{ height: "32px", width: "32px", borderRadius: "50%" }} alt="proile-pic" /> : <PersonIcon sx={{ fontSize: "25px" }} />}</Box>
                                              <Box>{values?.coach_first_name + " " + values?.coach_last_name}</Box>
                                            </Box>
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                      <ErrorMessage component={FormikErrorText} name="coach" />
                                    </Box>
                                    {edit && (
                                        <Box display="flex" gap="16px" alignItems="center">
                                          <Button type="submit" variant="primary_active">
                                            Update
                                          </Button>

                                          {!openDetails?.data?.cancelled_at && (
                                              <Button onClick={() => handleClickCancel(openDetails?.data?.id)} variant="primary_active">
                                                Cancel
                                              </Button>
                                          )}
                                          <Button onClick={handleCloseUpdate} variant="primary_inactive">
                                            Close
                                          </Button>
                                          <Button
                                              onClick={() => {
                                                setOpenDetails({
                                                  open: false,
                                                  data: null,
                                                });
                                                setVisible(true);
                                                setDate(initialValuesPrv?.start_time);
                                                setEdit(true);
                                                setSelectedSessionUpdate("private");
                                              }}
                                              variant="primary_active"
                                          >
                                            Schedule a new private lesson
                                          </Button>
                                        </Box>
                                    )}
                                    <Button variant="primary_active" onClick={() => navigate("/admin/players/schedule", { state: { data: openDetails?.data } })}>
                                      Go to details
                                    </Button>
                                  </Box>
                                </Form>
                            )}
                          </Formik>
                      )}
                      {selectedSessionUpdate === "court" && (
                          <Formik onSubmit={(values) => submitUpdateCourtBooking(values)} validationSchema={validationSchemaCourtBooking}
                                  initialValues={initialValuesCourtBooking} enableReinitialize={true}>
                            {({ errors, setFieldValue, values }) => (
                                <Form>
                                  <Box display="flex" flexDirection="column" gap="16px">
                                    <Box>
                                      <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                        Start time
                                      </Typography>
                                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DateTimePicker
                                            value={values.start_time}
                                            onChange={(value) => {
                                              setStartTime(new Date(value));
                                              setFieldValue("start_time", value);
                                              setFieldValue("coach", null);
                                            }}
                                            ampm={false}
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                      </LocalizationProvider>
                                      <ErrorMessage component={FormikErrorText} name="start_time" />
                                    </Box>
                                    <Box>
                                      <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                        Duration
                                      </Typography>
                                      <Autocomplete
                                          sx={{ minWidth: "300px" }}
                                          options={courtBookingDurations}
                                          disabled={!edit}
                                          value={values?.duration ? values?.duration : null}
                                          getOptionLabel={(e) => e?.duration?.toString()}
                                          isOptionEqualToValue={(option, value) => option?.duration === value?.duration}
                                          renderInput={(params) => <TextField {...params} name="autocomplete" placeholder="Select duration" />}
                                          onChange={(event, value) => {
                                            if (value !== null) {
                                              setFieldValue("duration", value);
                                              setDuration(value);
                                              setFieldValue("coach", null);
                                            } else {
                                              setFieldValue("duration", null);
                                              setDuration(null);
                                            }
                                          }}
                                      />
                                      <ErrorMessage component={FormikErrorText} name="duration" />
                                    </Box>
                                    <Box>
                                      <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                        Coach
                                      </Typography>
                                      <FormControl sx={{ height: "42px" }} fullWidth>
                                        <Select
                                            onChange={(e) => {
                                              setFieldValue("coach", e.target?.value);
                                            }}
                                            value={values?.coach}
                                            disabled={!edit}
                                            placeholder="Select coach"
                                            sx={{ height: "42px", borderColor: "#DEDFE4" }}
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                        >
                                          {coachs?.map((coach) => (
                                              <MenuItem key={coach?.id} value={coach?.id}>
                                                <Box display="flex" alignItems="center" gap="5px">
                                                  <Box marginTop="5px">{coach?.url_avatar ? <img src={coach?.url_avatar} style={{ height: "32px", width: "32px", borderRadius: "50%" }} alt="proile-pic" /> : <PersonIcon sx={{ fontSize: "25px" }} />}</Box>
                                                  <Box>{coach?.first_name + " " + coach?.last_name}</Box>
                                                </Box>
                                              </MenuItem>
                                          ))}
                                          <MenuItem key={values?.coach} value={values?.coach}>
                                            <Box display="flex" alignItems="center" gap="5px">
                                              <Box marginTop="5px">{values?.coach?.url_avatar ? <img src={values?.coach?.url_avatar} style={{ height: "32px", width: "32px", borderRadius: "50%" }} alt="proile-pic" /> : <PersonIcon sx={{ fontSize: "25px" }} />}</Box>
                                              <Box>{values?.coach_first_name + " " + values?.coach_last_name}</Box>
                                            </Box>
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                      <ErrorMessage component={FormikErrorText} name="coach" />
                                    </Box>
                                    {edit && (
                                        <Box display="flex" gap="16px" alignItems="center">
                                          <Button type="submit" variant="primary_active">
                                            Update
                                          </Button>

                                          {!openDetails?.data?.cancelled_at && (
                                              <Button onClick={() => handleClickCancel(openDetails?.data?.id)} variant="primary_active">
                                                Cancel
                                              </Button>
                                          )}
                                          <Button onClick={handleCloseUpdate} variant="primary_inactive">
                                            Close
                                          </Button>
                                          <Button
                                              onClick={() => {
                                                setOpenDetails({
                                                  open: false,
                                                  data: null,
                                                });
                                                setVisible(true);
                                                setDate(initialValuesPrv?.start_time);
                                                setEdit(true);
                                                setSelectedSessionUpdate("private");
                                              }}
                                              variant="primary_active"
                                          >
                                            Schedule a new private lesson
                                          </Button>
                                        </Box>
                                    )}
                                    <Button variant="primary_active" onClick={() => navigate("/admin/players/schedule", { state: { data: openDetails?.data } })}>
                                      Go to details
                                    </Button>
                                  </Box>
                                </Form>
                            )}
                          </Formik>
                      )}
                    </Box>
                  </Box>
                </Modal>

                {/*Modal 2*/}
                <Modal open={visible} onClose={() => setVisible(false)}>
                  <Box sx={modalStyleVertical}>
                    <Box>
                      <Box marginBottom="26px" alignItems="center" display="flex" justifyContent="space-between">
                        <Box>
                          <Typography fontSize="18px" lineHeight="24px" fontWeight="500" color="#4B465C">
                            Schedule session for {moment(date).format("dddd, MMMM DD, yyyy")}
                          </Typography>
                        </Box>
                        <ButtonSquare action="close" onClick={() => setVisible(false)} />
                      </Box>
                      <Formik onSubmit={(values) => submitCreatePrivateLesson(values)} validationSchema={validationSchemaPrivate} initialValues={initialValuesPrv} enableReinitialize={true}>
                        {({ errors, setFieldValue, values }) => (
                            <Form>
                              <Box display="flex" flexDirection="column" gap="16px">
                                <Box>
                                  <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                    Start time
                                  </Typography>
                                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DateTimePicker
                                        value={values.start_time}
                                        onChange={(value) => {
                                          setStartTime(new Date(value));
                                          setFieldValue("start_time", value);
                                          setFieldValue("coach", null);
                                        }}
                                        ampm={false}
                                        disableIgnoringDatePartForTimeValidation={true}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                  </LocalizationProvider>
                                  <ErrorMessage component={FormikErrorText} name="start_time" />
                                </Box>
                                <Box>
                                  <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                    Duration
                                  </Typography>
                                  <Autocomplete
                                      sx={{ minWidth: "300px" }}
                                      options={durations}
                                      disabled={!edit}
                                      value={values?.duration ? values?.duration : null}
                                      getOptionLabel={(e) => e?.duration?.toString()}
                                      isOptionEqualToValue={(option, value) => option?.duration === value?.duration}
                                      renderInput={(params) => <TextField {...params} name="autocomplete" placeholder="Select duration" />}
                                      onChange={(event, value) => {
                                        if (value !== null) {
                                          setFieldValue("duration", value);
                                          setDuration(value);
                                          setFieldValue("coach", null);
                                        } else {
                                          setFieldValue("duration", null);
                                          setDuration(null);
                                        }
                                      }}
                                  />
                                  <ErrorMessage component={FormikErrorText} name="duration" />
                                </Box>
                                <Box>
                                  <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                    Coach
                                  </Typography>
                                  <FormControl sx={{ height: "42px" }} fullWidth>
                                    <Select
                                        onChange={(e) => {
                                          setFieldValue("coach", e.target?.value);
                                        }}
                                        value={values?.coach}
                                        disabled={!edit}
                                        placeholder="Select coach"
                                        sx={{ height: "42px", borderColor: "#DEDFE4" }}
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                    >
                                      {coachs?.map((coach) => (
                                          <MenuItem key={coach?.id} value={coach?.id}>
                                            <Box display="flex" alignItems="center" gap="5px">
                                              <Box marginTop="5px">{coach?.url_avatar ? <img src={coach?.url_avatar} style={{ height: "32px", width: "32px", borderRadius: "50%" }} alt="proile-pic" /> : <PersonIcon sx={{ fontSize: "25px" }} />}</Box>
                                              <Box>{coach?.first_name + " " + coach?.last_name}</Box>
                                            </Box>
                                          </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                  <ErrorMessage component={FormikErrorText} name="coach" />
                                </Box>
                                <Box display="flex" gap="16px" alignItems="center">
                                  <Button type="submit" variant="primary_active">
                                    Add
                                  </Button>

                                  <Button onClick={handleCloseUpdate} variant="primary_inactive">
                                    Close
                                  </Button>
                                </Box>
                              </Box>
                            </Form>
                        )}
                      </Formik>
                    </Box>
                  </Box>
                </Modal>
              </Box>
            </ContentBox>
        ) : (
            <Box display="flex" flexDirection="column" gap="26px" alignItems="start">
              <ToastContainer />
              <Box>
                <Typography fontSize="22px" fontWeight="500" lineHeight="30px" color="#4B465C">
                  Schedule
                </Typography>
              </Box>

              {term && showFilter && (
                  <Box width="100%">
                    <ContentBox>
                      <Box width="100%" display="flex" gap="16px">
                        <Box flex={1}>
                          <Typography fontSize="13px" fontWeight={400} lineHeight="20px" color="#4B465C">
                            Select term
                          </Typography>
                          <Autocomplete
                              fullWidth
                              options={terms}
                              value={term}
                              disableClearable={true}
                              getOptionLabel={(e) => e.name}
                              isOptionEqualToValue={(option, value) => option?.id === value?.id}
                              onChange={(event, value) => {
                                if (value !== null) {
                                  setTerm(value);
                                } else {
                                  setTerm(null);
                                }
                              }}
                              renderInput={(params) => <TextField {...params} name="autocomplete" placeholder="Select term" />}
                          />
                        </Box>
                        <Box flex={1}>
                          <Typography fontSize="13px" fontWeight={400} lineHeight="20px" color="#4B465C">
                            Select court
                          </Typography>
                          <Autocomplete
                              fullWidth
                              options={courts}
                              value={court}
                              disableClearable={true}
                              getOptionLabel={(e) => e.name}
                              isOptionEqualToValue={(option, value) => option?.id === value.id}
                              onChange={(event, value) => {
                                if (value !== null) {
                                  setCourt(value);
                                } else {
                                  setCourt(null);
                                }
                              }}
                              renderInput={(params) => <TextField {...params} name="autocomplete" placeholder="Select court" />}
                          />
                        </Box>
                      </Box>
                    </ContentBox>
                  </Box>
              )}
              <ContentBox>
                <Box sx={{ overflowX: { xs: "scroll", sm: "scroll", md: "hidden", lg: "hidden" }, flexDirection: { xs: "column", sm: "column", md: "column", lg: "row" } }} display="flex" gap="26px">
                  {showFilter && (
                      <Box flex={1} display="flex" flexDirection="column" gap="12px">
                        <Box>
                          <Typography fontSize="13px" fontWeight={400} lineHeight="20px" color="#4B465C">
                            Filter
                          </Typography>
                        </Box>
                        <Box display="flex" gap="10px" alignItems="center">
                          <Typography fontSize="20px" fontWeight={600} color={colors.darkgray}>
                            PRIVATE LESSONS
                          </Typography>
                          <MySwitch
                              isOn={sessionType === "PRIVATE_LESSON"}
                              onChange={() =>
                                  setSessionType(sessionType === "PRIVATE_LESSON" ? "PROGRAM" : "PRIVATE_LESSON")
                              }
                          />
                        </Box>

                        {/* Filtre pour COURT BOOKINGS */}
                        <Box display="flex" gap="10px" alignItems="center">
                          <Typography fontSize="20px" fontWeight={600} color={colors.darkgray}>
                            COURT BOOKINGS
                          </Typography>
                          <MySwitch
                              isOn={sessionType === "COURT_BOOKING"}
                              onChange={() =>
                                  setSessionType(sessionType === "COURT_BOOKING" ? "PROGRAM" : "COURT_BOOKING")
                              }
                          />
                        </Box>
                        <Box display="flex" gap="10px" flexDirection="row" alignItems="center">
                          <Typography fontSize="20px" fontWeight={600} color={colors.darkgray}>
                            CANCELLED SLOTS
                          </Typography>
                          <MySwitch
                              isOn={showCanceledSlots}
                              onChange={() => {
                                setShowCanceledSlots(!showCanceledSlots);
                              }}
                          />
                        </Box>
                        {selectedSession === "normal" && (
                            <Box>
                              <Typography fontSize="13px" fontWeight={400} lineHeight="20px" color="#4B465C">
                                Program
                              </Typography>
                              <Autocomplete
                                  sx={{ minWidth: "200px" }}
                                  options={programs}
                                  value={programFilter}
                                  getOptionLabel={(e) => e.name}
                                  isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                  onChange={(event, value) => {
                                    if (value !== null) {
                                      setProgramFilter(value);
                                    } else {
                                      setProgramFilter(null);
                                    }
                                  }}
                                  renderInput={(params) => <TextField {...params} name="autocomplete" placeholder="Select type user" />}
                              />
                            </Box>
                        )}
                        <Box>
                          <Typography fontSize="13px" fontWeight={400} lineHeight="20px" color="#4B465C">
                            Coach
                          </Typography>
                          <Autocomplete
                              sx={{ minWidth: "200px" }}
                              options={users}
                              getOptionLabel={(e) => e.first_name + " " + e.last_name}
                              isOptionEqualToValue={(option, value) => option?.id === value?.id}
                              onChange={(event, value) => {
                                if (value !== null) {
                                  setCoachFil(value);
                                } else {
                                  setCoachFil(null);
                                }
                              }}
                              renderInput={(params) => <TextField {...params} name="autocomplete" placeholder="Select coach" />}
                          />
                        </Box>
                        <Box>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <CalendarPicker
                                date={selectedDate}
                                maxDate={term?.end_date}
                                minDate={term?.start_date}
                                onChange={(newValue) => {
                                  setSelectedDate(newValue);
                                }}
                                renderInput={(params) => <TextField {...params} />}
                            />
                          </LocalizationProvider>
                        </Box>
                      </Box>
                  )}

                  <Box flex={4} sx={{ width: "100%" }} borderLeft={showFilters === false ? "none" : "1px solid lightgray"}>
                    {!loading && !schedule && <Typography textAlign="center">No schedules</Typography>}
                    {!loading && schedule && (
                        <Scheduler data={schedule} height={700}>
                          <ViewState onCurrentDateChange={!dateS ? (date) => (new Date(date) < new Date(term?.start_date) ? setSelectedDate(new Date(term?.start_date)) : new Date(term?.start_date) < new Date(date) && new Date(term?.end_date) > new Date(date) ? setSelectedDate(date) : setSelectedDate(new Date(term?.end_date))) : (date) => setDateS(date)} currentDate={dateS ? dateSe : selectedDate} currentViewName={currentViewName} />
                          <WeekView cellDuration={30} startDayHour={6} endDayHour={22} />
                          <MonthView />
                          <DayView cellDuration={30} startDayHour={6} endDayHour={22} />
                          <Appointments appointmentComponent={CustomAppointmentContent} />

                          <Toolbar />
                          <Box marginLeft="20px" display="flex" alignItems="center" justifyContent="space-between">
                            <Typography fontSize="18px" fontWeight="500" lineHeight="24px" color="#4B465C">
                              TERM : {term?.name} {court?.name ? " / " : ""} {court?.name}{" "}
                            </Typography>
                            {showFilters === false && (
                                <Box>
                                  <Button onClick={() => navigate("/admin/schedules")} variant="primary_active">
                                    Go to schedule
                                  </Button>
                                </Box>
                            )}
                          </Box>
                          <DateNavigator onCurrentDateChange={(date) => console.log(date)} />
                          <ExternalViewSwitcher currentViewName={currentViewName} />
                          <EditingState />
                          <AppointmentForm
                              visible={visible}
                              onAppointmentDataChange={(data) => {
                                setDate(data?.startDate);
                                setStartTime(data?.startDate);
                                setInitialValuesPrv({
                                  program: program,
                                  levels: [],
                                  start_time: data?.startDate, //new Date(),
                                  duration: "",
                                  coach: "",
                                });
                                setInitialValuesCourtBooking({
                                  start_time: data?.startDate, //new Date(),
                                  duration: "",
                                });
                              }}
                              onVisibilityChange={(e) => {
                                setSelectedSessionUpdate("private");
                                setVisible(e);
                                setEdit(true);

                              }}
                              overlayComponent={() => {
                                return null;
                              }}
                          />
                        </Scheduler>
                    )}
                    {loading && (
                        <Box sx={{ minWidth: "800px", display: "flex", justifyContent: "center" }}>
                          <CircularProgress />
                        </Box>
                    )}
                  </Box>
                   {/*Modal 3*/}
                  <Modal open={openDetails?.open} onClose={handleCloseUpdate}>
                    <Box sx={modalStyleVertical}>
                      <Box>
                        <Box marginBottom="26px" alignItems="center" display="flex" justifyContent="space-between">
                          <Box>
                            <Typography fontSize="18px" lineHeight="24px" fontWeight="500" color="#4B465C">
                              Schedule session for {moment(openDetails?.data?.start_datetime).format("dddd, MMMM DD, yyyy hh:mm A")}
                            </Typography>
                          </Box>
                          <ButtonSquare action="close" onClick={handleCloseUpdate} />
                        </Box>
                        <Box display="flex" gap="4px" marginBottom="24px">
                          <Box>
                            <Button variant={selectedSessionUpdate === "normal" ? "primary_active" : "primary_inactive"}>Schedule a session</Button>
                          </Box>
                          <Box>
                            <Button
                                onClick={() => {
                                  setOpenDetails({
                                    open: false,
                                    data: null,
                                  });
                                  setVisible(true);
                                  //setDate(initialValuesNorml?.start_time);
                                  setEdit(true);
                                  setSelectedSessionUpdate("private");
                                }}
                                variant={selectedSessionUpdate === "private" ? "primary_active" : "primary_inactive"}
                            >
                              Schedule a private session
                            </Button>
                          </Box>
                          <Button onClick={() => {
                            setCoachs([]);
                            setOpenDetails({
                              open: false,
                              data: null,
                            });
                            setVisible(true);
                            //setDate(initialValuesNorml?.start_time);
                            setEdit(true);
                            setSelectedSessionUpdate("court");
                          }}
                                  variant={selectedSessionUpdate === "court" ? "primary_active" : "primary_inactive"}>
                            Schedule a court booking
                          </Button>
                        </Box>
                        {selectedSessionUpdate === "normal" && (
                            <Formik onSubmit={(values) => console.log(values)} validationSchema={validationSchema} initialValues={initialValuesNorml} enableReinitialize={true}>
                              {({ errors, setFieldValue, values }) => (
                                  <Form>
                                    <Box display="flex" flexDirection="column" gap="16px">
                                      <Box>
                                        <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                          Program
                                        </Typography>
                                        <Autocomplete
                                            sx={{ minWidth: "300px" }}
                                            options={[]}
                                            value={values?.program}
                                            disabled={!edit}
                                            getOptionLabel={(e) => e.name}
                                            isOptionEqualToValue={(option, value) => option?.id === value.id}
                                            renderInput={(params) => <TextField {...params} name="autocomplete" placeholder="Select program" />}
                                            onChange={(event, value) => {
                                              if (value !== null) {
                                                setFieldValue("program", value);
                                                setFieldValue("coach", null);
                                                setProgram(value);
                                                setFieldValue("duration", null);
                                              } else {
                                                setFieldValue("program", null);
                                              }
                                            }}
                                        />
                                        <ErrorMessage component={FormikErrorText} name="program" />
                                      </Box>

                                      <Box>
                                        <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                          Levels
                                        </Typography>
                                        <Autocomplete
                                            multiple
                                            options={levels}
                                            value={values.levels || []}
                                            onChange={(event, newValue) => setFieldValue("levels", newValue)}
                                            getOptionLabel={(option) => option.name || ""}
                                            filterSelectedOptions
                                            renderInput={(params) => (
                                                <TextField {...params} placeholder="Select level(s)" />
                                            )}
                                        />
                                        <ErrorMessage component={FormikErrorText} name="levels" />
                                      </Box>
                                      <Box>
                                        <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                          Start time
                                        </Typography>
                                        <Autocomplete
                                            onChange={(event, value) => {
                                              if (value !== null) {
                                                setFieldValue("start_time", value);
                                                setStartTime(value);
                                                setFieldValue("coach", null);

                                              } else {
                                                setFieldValue("start_time", null);
                                                setStartTime(null);
                                                setFieldValue("coach", null);
                                              }
                                            }}
                                            sx={{ minWidth: "300px" }}
                                            options={[]}
                                            disabled={!edit}
                                            value={moment(values?.start_time).format("DD MMMM YYYY hh:mm A")}
                                            getOptionLabel={(e) => e}
                                            isOptionEqualToValue={(option, value) => option === value}
                                            renderInput={(params) => <TextField {...params} name="autocomplete" placeholder="Select start time" />}
                                        />
                                        <ErrorMessage component={FormikErrorText} name="start_time" />
                                      </Box>
                                      <Box>
                                        <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                          Duration
                                        </Typography>
                                        <Autocomplete
                                            sx={{ minWidth: "300px" }}
                                            options={[]}
                                            disabled={!edit}
                                            value={values?.duration ? values?.duration : null}
                                            getOptionLabel={(e) => e?.duration?.toString()}
                                            isOptionEqualToValue={(option, value) => option?.duration === value?.duration}
                                            renderInput={(params) => <TextField {...params} name="autocomplete" placeholder="Select duration" />}
                                            onChange={(event, value) => {
                                              if (value !== null) {
                                                setFieldValue("duration", value);
                                                setDuration(value);
                                                setFieldValue("coach", null);
                                              } else {
                                                setFieldValue("duration", null);
                                                setDuration(null);
                                              }
                                            }}
                                        />
                                        <ErrorMessage component={FormikErrorText} name="duration" />
                                      </Box>
                                      <Box>
                                        <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                          Coach
                                        </Typography>
                                        <FormControl sx={{ height: "42px" }} fullWidth>
                                          <Select
                                              onChange={(e) => {
                                                setFieldValue("coach", e.target?.value);
                                              }}
                                              disabled={!edit}
                                              value={values?.coach}
                                              placeholder="Select coach"
                                              sx={{ height: "42px", borderColor: "#DEDFE4" }}
                                              labelId="demo-simple-select-label"
                                              id="demo-simple-select"
                                          >
                                            <MenuItem key={values?.coach} value={values?.coach}>
                                              <Box display="flex" alignItems="center" gap="5px">
                                                <Box marginTop="5px">{values?.coach?.url_avatar ? <img src={values?.coach?.url_avatar} style={{ height: "32px", width: "32px", borderRadius: "50%" }} alt="proile-pic" /> : <PersonIcon sx={{ fontSize: "25px" }} />}</Box>
                                                <Box>{values?.coach_first_name + " " + values?.coach_last_name}</Box>
                                              </Box>
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                        <ErrorMessage component={FormikErrorText} name="coach" />
                                      </Box>
                                      <Box display="flex" gap="16px" alignItems="center">
                                        {!openDetails?.data?.cancelled_at && (
                                            <Button onClick={() => handleClickCancel(openDetails?.data?.id)} variant="primary_active">
                                              Cancel
                                            </Button>
                                        )}
                                        <Button onClick={handleCloseUpdate} variant="primary_inactive">
                                          Close
                                        </Button>
                                        <Button variant="primary_active" onClick={() => navigate("/admin/players/schedule", { state: { data: openDetails?.data } })}>
                                          Go to details
                                        </Button>{" "}
                                      </Box>
                                    </Box>
                                  </Form>
                              )}
                            </Formik>
                        )}
                        {selectedSessionUpdate === "private" && (
                            <Formik onSubmit={(values) => submitUpdatePrivateCourt(values)} validationSchema={validationSchemaPrivate} initialValues={initialValuesPrv} enableReinitialize={true}>
                              {({ errors, setFieldValue, values }) => (
                                  <Form>
                                    <Box display="flex" flexDirection="column" gap="16px">
                                      <Box>
                                        <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                          Start time
                                        </Typography>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                          <DateTimePicker
                                              value={values.start_time}
                                              onChange={(value) => {
                                                setStartTime(new Date(value));
                                                setFieldValue("start_time", value);
                                                setFieldValue("coach", null);
                                              }}
                                              ampm={false}
                                              renderInput={(params) => <TextField {...params} />}
                                          />
                                        </LocalizationProvider>
                                        <ErrorMessage component={FormikErrorText} name="start_time" />
                                      </Box>
                                      <Box>
                                        <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                          Duration
                                        </Typography>
                                        <Autocomplete
                                            sx={{ minWidth: "300px" }}
                                            options={durations}
                                            disabled={!edit}
                                            value={values?.duration ? values?.duration : null}
                                            getOptionLabel={(e) => e?.duration?.toString()}
                                            isOptionEqualToValue={(option, value) => option?.duration === value?.duration}
                                            renderInput={(params) => <TextField {...params} name="autocomplete" placeholder="Select duration" />}
                                            onChange={(event, value) => {
                                              if (value !== null) {
                                                setFieldValue("duration", value);
                                                setDuration(value);
                                                setFieldValue("coach", null);
                                              } else {
                                                setFieldValue("duration", null);
                                                setDuration(null);
                                              }
                                            }}
                                        />
                                        <ErrorMessage component={FormikErrorText} name="duration" />
                                      </Box>
                                      <Box>
                                        <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                          Coach
                                        </Typography>
                                        <FormControl sx={{ height: "42px" }} fullWidth>
                                          <Select
                                              onChange={(e) => {
                                                setFieldValue("coach", e.target?.value);
                                              }}
                                              value={values?.coach}
                                              disabled={!edit}
                                              placeholder="Select coach"
                                              sx={{ height: "42px", borderColor: "#DEDFE4" }}
                                              labelId="demo-simple-select-label"
                                              id="demo-simple-select"
                                          >
                                            {coachs?.map((coach) => (
                                                <MenuItem key={coach?.id} value={coach?.id}>
                                                  <Box display="flex" alignItems="center" gap="5px">
                                                    <Box marginTop="5px">{coach?.url_avatar ? <img src={coach?.url_avatar} style={{ height: "32px", width: "32px", borderRadius: "50%" }} alt="proile-pic" /> : <PersonIcon sx={{ fontSize: "25px" }} />}</Box>
                                                    <Box>{coach?.first_name + " " + coach?.last_name}</Box>
                                                  </Box>
                                                </MenuItem>
                                            ))}
                                            <MenuItem key={values?.coach} value={values?.coach}>
                                              <Box display="flex" alignItems="center" gap="5px">
                                                <Box marginTop="5px">{values?.coach?.url_avatar ? <img src={values?.coach?.url_avatar} style={{ height: "32px", width: "32px", borderRadius: "50%" }} alt="proile-pic" /> : <PersonIcon sx={{ fontSize: "25px" }} />}</Box>
                                                <Box>{values?.coach_first_name + " " + values?.coach_last_name}</Box>
                                              </Box>
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                        <ErrorMessage component={FormikErrorText} name="coach" />
                                      </Box>
                                      {edit && (
                                          <Box display="flex" gap="16px" alignItems="center">
                                            {/*<Button type="submit" variant="primary_active">
                                    Update
                                  </Button>*/}

                                            {!openDetails?.data?.cancelled_at && (
                                                <Button onClick={() => handleClickCancel(openDetails?.data?.id)} variant="primary_active">
                                                  Cancel
                                                </Button>
                                            )}
                                            <Button onClick={handleCloseUpdate} variant="primary_inactive">
                                              Close
                                            </Button>
                                            <Button
                                                onClick={() => {
                                                  setOpenDetails({
                                                    open: false,
                                                    data: null,
                                                  });
                                                  setVisible(true);
                                                  setDate(initialValuesPrv?.start_time);
                                                  setEdit(true);
                                                  setSelectedSessionUpdate("private");
                                                }}
                                                variant="primary_active"
                                            >
                                              Schedule a new private lesson
                                            </Button>
                                          </Box>
                                      )}
                                      <Button variant="primary_active" onClick={() => navigate("/admin/players/schedule", { state: { data: openDetails?.data } })}>
                                        Go to details
                                      </Button>
                                    </Box>
                                  </Form>
                              )}
                            </Formik>
                        )}
                        {selectedSessionUpdate === "court" && (
                            <Formik onSubmit={(values) =>
                                submitUpdateCourtBooking(values)} validationSchema={validationSchemaCourtBooking} initialValues={initialValuesCourtBooking} enableReinitialize={true}>
                              {({ errors, setFieldValue, values }) => (
                                  <Form>
                                    <Box display="flex" flexDirection="column" gap="16px">
                                      <Box>
                                        <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                          Start time
                                        </Typography>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                          <DateTimePicker
                                              value={values.start_time}
                                              onChange={(value) => {
                                                setStartTime(new Date(value));
                                                setFieldValue("start_time", value);
                                              }}
                                              ampm={false}
                                              renderInput={(params) => <TextField {...params} />}
                                          />
                                        </LocalizationProvider>
                                        <ErrorMessage component={FormikErrorText} name="start_time" />
                                      </Box>
                                      <Box>
                                        <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                          Duration
                                        </Typography>
                                        <Autocomplete
                                            sx={{ minWidth: "300px" }}
                                            options={courtBookingDurations}
                                            disabled={!edit}
                                            value={values?.duration ? values?.duration : null}
                                            getOptionLabel={(e) => e?.duration?.toString()}
                                            isOptionEqualToValue={(option, value) => option?.duration === value?.duration}
                                            renderInput={(params) => <TextField {...params} name="autocomplete" placeholder="Select duration" />}
                                            onChange={(event, value) => {
                                              if (value !== null) {
                                                setFieldValue("duration", value);
                                                /*setCourtBookingDurations(value);*/
                                                setFieldValue("coach", null);
                                              } else {
                                                setFieldValue("duration", null);
                                                setCourtBookingDurations(null);
                                              }
                                            }}
                                        />
                                        <ErrorMessage component={FormikErrorText} name="duration" />
                                      </Box>
                                      {edit && (
                                          <Box display="flex" gap="16px" alignItems="center">
                                            {/* <Button type="submit" variant="primary_active">
                                          Update
                                        </Button>*/}

                                            {!openDetails?.data?.cancelled_at && (
                                                <Button onClick={() => handleClickCancel(openDetails?.data?.id)} variant="primary_active">
                                                  Cancel
                                                </Button>
                                            )}
                                            <Button onClick={handleCloseUpdate} variant="primary_inactive">
                                              Close
                                            </Button>
                                            <Button
                                                onClick={() => {
                                                  setOpenDetails({
                                                    open: false,
                                                    data: null,
                                                  });
                                                  setVisible(true);
                                                  setDate(initialValuesCourtBooking?.start_time);
                                                  setEdit(true);
                                                  setSelectedSessionUpdate("court");
                                                }}
                                                variant="primary_active"
                                            >
                                              Schedule a new court booking
                                            </Button>
                                          </Box>
                                      )}
                                    </Box>
                                  </Form>
                              )}
                            </Formik>
                        )}
                      </Box>
                    </Box>
                  </Modal>

                  {/*Modal 4*/}
                  <Modal open={visible} onClose={() => setVisible(false)}>
                    <Box sx={modalStyleVertical}>
                      <Box>
                        <Box marginBottom="26px" alignItems="center" display="flex" justifyContent="space-between">
                          <Box>
                            <Typography fontSize="18px" lineHeight="24px" fontWeight="500" color="#4B465C">
                              Schedule session for {moment(date).format("DD MMMM YYYY")}
                            </Typography>
                          </Box>
                          <ButtonSquare action="close" onClick={() => setVisible(false)} />
                        </Box>
                        <Box display="flex" gap="4px" marginBottom="24px">
                          <Box>
                            <Button
                                onClick={() => {
                                  setOpenDetails({
                                    open: false,
                                    data: null,
                                  });
                                  setVisible(true);
                                  //setDate(initialValuesPrv?.start_time);
                                  //setDate(startTime);
                                  setStartTime(startTime)
                                  setEdit(true);
                                  setSelectedSessionUpdate("private");
                                }}
                                variant={selectedSessionUpdate === "private" ? "primary_active" : "primary_inactive"}
                            >
                              Schedule a private session
                            </Button>
                          </Box>
                          <Button
                              onClick={() => {
                                setCoachs([]);
                                setOpenDetails({
                                  open: false,
                                  data: null,
                                });
                                setVisible(true);
                                //setDate(startTime);
                                setStartTime(startTime)
                                setEdit(true);
                                setSelectedSessionUpdate("court");
                              }}
                              variant={selectedSessionUpdate === "court" ? "primary_active" : "primary_inactive"}>
                            Schedule a court booking
                          </Button>
                        </Box>
                        {selectedSessionUpdate === "private" && (
                            <Formik onSubmit={(values) => submitCreatePrivateLesson(values)} validationSchema={validationSchemaPrivate} initialValues={initialValuesPrv} enableReinitialize={true}>
                              {({ errors, setFieldValue, values }) => (
                                  <Form>
                                    <Box display="flex" flexDirection="column" gap="16px">
                                      <Box>
                                        <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                          Start time
                                        </Typography>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                          <DateTimePicker
                                              value={moment(values?.start_time).format("DD MMMM YYYY hh:mm A")}
                                              onChange={(value) => {
                                                setStartTime(new Date(value));
                                                setFieldValue("start_time", value);
                                                setFieldValue("coach", null);
                                              }}
                                              ampm={false}
                                              disableIgnoringDatePartForTimeValidation={true}
                                              renderInput={(params) => <TextField {...params} />}
                                          />
                                        </LocalizationProvider>
                                        <ErrorMessage component={FormikErrorText} name="start_time" />
                                      </Box>
                                      <Box>
                                        <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                          Duration
                                        </Typography>
                                        <Autocomplete
                                            sx={{ minWidth: "300px" }}
                                            options={durations}
                                            disabled={!edit}
                                            /*value={values?.duration ? values?.duration : null}*/
                                            getOptionLabel={(e) => e?.duration?.toString()}
                                            isOptionEqualToValue={(option, value) => option?.duration === value?.duration}
                                            renderInput={(params) => <TextField {...params} name="autocomplete" placeholder="Select duration" />}
                                            onChange={(event, value) => {
                                              if (value !== null) {
                                                setFieldValue("duration", value);
                                                setDuration(value);
                                                setFieldValue("coach", null);
                                              } else {
                                                setFieldValue("duration", null);
                                                setDuration(null);
                                              }
                                            }}
                                        />
                                        <ErrorMessage component={FormikErrorText} name="duration" />
                                      </Box>
                                      <Box>
                                        <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                          Coach
                                        </Typography>
                                        <FormControl sx={{ height: "42px" }} fullWidth>
                                          <Select
                                              onChange={(e) => {
                                                setFieldValue("coach", e.target?.value);
                                              }}
                                              value={values?.coach}
                                              disabled={!edit}
                                              placeholder="Select coach"
                                              sx={{ height: "42px", borderColor: "#DEDFE4" }}
                                              labelId="demo-simple-select-label"
                                              id="demo-simple-select"
                                          >
                                            {coachs?.map((coach) => (
                                                <MenuItem key={coach?.id} value={coach?.id}>
                                                  <Box display="flex" alignItems="center" gap="5px">
                                                    <Box marginTop="5px">{coach?.url_avatar ? <img src={coach?.url_avatar} style={{ height: "32px", width: "32px", borderRadius: "50%" }} alt="proile-pic" /> : <PersonIcon sx={{ fontSize: "25px" }} />}</Box>
                                                    <Box>{coach?.first_name + " " + coach?.last_name}</Box>
                                                  </Box>
                                                </MenuItem>
                                            ))}
                                          </Select>
                                        </FormControl>
                                        <ErrorMessage component={FormikErrorText} name="coach" />
                                      </Box>
                                      <Box display="flex" gap="16px" alignItems="center">
                                        <Button type="submit" variant="primary_active">
                                          Add
                                        </Button>

                                        <Button onClick={handleCloseUpdate} variant="primary_inactive">
                                          Close
                                        </Button>
                                      </Box>
                                    </Box>
                                  </Form>
                              )}
                            </Formik>
                        )}
                        {selectedSessionUpdate === "court" && (
                            <Formik onSubmit={(values) => submitCreateCourtBooking(values)} validationSchema={validationSchemaCourtBooking}
                                    initialValues={initialValuesCourtBooking} enableReinitialize={true}>
                              {({ errors, setFieldValue, values }) => (
                                  <Form>
                                    <Box display="flex" flexDirection="column" gap="16px">
                                      <Box>
                                        <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                          Start time
                                        </Typography>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                          <DateTimePicker
                                              value={moment(values?.start_time).format("DD MMMM YYYY hh:mm A")}
                                              onChange={(value) => {
                                                setStartTime(new Date(value));
                                                setFieldValue("start_time", value);
                                              }}
                                              ampm={false}
                                              disableIgnoringDatePartForTimeValidation={true}
                                              renderInput={(params) => <TextField {...params} />}
                                          />
                                        </LocalizationProvider>
                                        <ErrorMessage component={FormikErrorText} name="start_time" />
                                      </Box>
                                      <Box>
                                        <Typography fontSize="13px" fontWeight="400" color="#4B465C">
                                          Duration
                                        </Typography>
                                        <Autocomplete
                                            sx={{ minWidth: "300px" }}
                                            options={courtBookingDurations}
                                            disabled={!edit}
                                            /*value={values?.duration ? values?.duration : null}*/
                                            getOptionLabel={(e) => e?.duration?.toString()}
                                            isOptionEqualToValue={(option, value) => option?.duration === value?.duration}
                                            renderInput={(params) => <TextField {...params} name="autocomplete" placeholder="Select duration" />}
                                            onChange={(_, value) => {
                                              setFieldValue("duration", value);   // Formik garde l’objet sélectionné
                                              if (value !== null) {
                                                setFieldValue("duration", value);
                                                setCourtBookingDurations(value);
                                              } else {
                                                setFieldValue("duration", null);
                                              }
                                            }}
                                        />
                                        <ErrorMessage component={FormikErrorText} name="duration" />
                                      </Box>
                                      <Box display="flex" gap="16px" alignItems="center">
                                        <Button type="submit" variant="primary_active">
                                          Add
                                        </Button>

                                        <Button onClick={handleCloseUpdate} variant="primary_inactive">
                                          Close
                                        </Button>
                                      </Box>
                                    </Box>
                                  </Form>
                              )}
                            </Formik>
                        )}
                      </Box>
                    </Box>
                  </Modal>
                </Box>
              </ContentBox>
              <Modal open={addedScheduleToshow?.open} onClose={() => setAddedScheduleToshow({ open: false, data: null })}>
                <Box sx={modalStyleOverflow}>
                  <Box position="absolute" top="2px" right="2px">
                    <ButtonSquare action="close" onClick={() => setAddedScheduleToshow({ open: false, data: null })} />
                  </Box>
                  <Box display="flex" justifyContent="center" marginBottom="16px">
                    <Box display="flex" flexDirection="column" gap="16px" width="70%">
                      {addedScheduleToshow?.data?.map((data) => (
                          <Box height="100px" display="flex" justifyContent="center">
                            <CustomAppointmentContent data={data} />
                          </Box>
                      ))}
                    </Box>
                  </Box>
                  <Box display="flex" justifyContent="center">
                    <Button onClick={() => setAddedScheduleToshow({ open: false, data: null })} variant="primary_inactive">
                      Close
                    </Button>
                  </Box>
                </Box>
              </Modal>
              <Modal open={openCancelSession?.open} onClose={handleCloseCancel}>
                <Box sx={modalStyleOverflow}>
                  <Box position="absolute" top="2px" right="2px">
                    <ButtonSquare action="close" onClick={handleCloseCancel} />
                  </Box>
                  <Box>
                    <Typography textAlign="center" fontSize="22px" lineHeight="32px" fontWeight="500" color="#4B465C">
                      Would you like to refund this session ?
                    </Typography>
                  </Box>
                  <Box marginTop="16px" justifyContent="center" display="flex" gap="16px">
                    <Button disabled={loadingCancel} onClick={() => handleCancelAppointement(true)} variant="primary_active">
                      Refund
                    </Button>
                    <Button disabled={loadingCancel} onClick={() => handleCancelAppointement(false)} variant="primary_inactive">
                      Do not refund
                    </Button>
                  </Box>
                </Box>
              </Modal>
            </Box>
        )}
      </Box>
  );
}

export default Schedule;
